import { PermissionsStore as PermissionsStoreCore } from '@platform/ics-front-core';
import { AccountPermissions } from '@platform/ics-front-core';
import { getAccountPermissionsConfig } from './PermissionsConfigs';

export class PermissionsStore extends PermissionsStoreCore {
    get accountConfig(): AccountPermissions {
        return getAccountPermissionsConfig(this.entities, this.permissions);
    }
}
